export function resaDemandReducer(state = { 
},{
    type,
    payload
}){
    
    switch(type){
        case "NEW_RESA_DEMAND": 
        case "UPDATE_RESA_DEMAND": 
            return {
                [payload.id]: payload,
                ...state
            };
        case "RECEIVED_RESA_DEMAND":        
            return {
                ...state,
                [payload]: {
                    ...state[payload],
                    received: true
                }
            }
        case "GET_RESA_DEMANDS":        
            return payload;
        
        case "DELETE_RESA_DEMAND":
            const { [payload]: deleted, ...newState } = state;
            return newState;
        default:
            return state;
    }
    
}